module.exports = __webpack_public_path__ + "img/New Year 5.bcfbbdd9.jpeg";